module.exports = __webpack_public_path__ + "img/Step2.f8fd3b22.png";